// Hooks
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
// CSS
import "./Message.css";

const Message = ({ msg, type, timeout = true }) => {
  const [warningType, setWarningType] = useState(type);
  const { t } = useTranslation();

  useEffect(() => {
    if (timeout) {
      setTimeout(() => {
        setWarningType("d-none");
      }, 4500);
    }
  });

  const message =
    typeof msg === "string"
      ? msg
      : msg?.data?.errors?.[0] ||
        msg?.data?.detail ||
        msg?.error ||
        msg?.message ||
        t("GenericErrorMessage");

  const translatedMessage =
    message.includes("Formato de arquivo compactado não suportado ou inválido.")
      ? t("InvalidArchiveMessage")
      : message;

  return (
    <div className={`message ${warningType}`}>
      <p>{translatedMessage}</p>
    </div>
  );
};

export default Message;
